
export const isIOSSafari = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  return isIOS && isSafari;
};

export const isIOSInstallable = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isStandalone = (window.navigator as any).standalone;
  
  console.log('PWA Debug - iOS Detection:', {
    userAgent,
    isIOS,
    isStandalone,
    isIOSInstallable: isIOS && !isStandalone
  });
  
  return isIOS && !isStandalone;
};

export const isDesktopChrome = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isChrome = /Chrome/.test(userAgent) && !/Mobile/.test(userAgent);
  const isDesktop = window.innerWidth >= 768;
  
  console.log('PWA Debug - Desktop Chrome Detection:', {
    userAgent,
    isChrome,
    isDesktop,
    isDesktopChrome: isChrome && isDesktop
  });
  
  return isChrome && isDesktop;
};

export const debugPWAState = () => {
  console.log('PWA Debug - Full State:', {
    userAgent: window.navigator.userAgent,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    isStandalone: (window.navigator as any).standalone,
    displayMode: window.matchMedia('(display-mode: standalone)').matches,
    isIOSInstallable: isIOSInstallable(),
    isDesktopChrome: isDesktopChrome(),
    localStorageDismissed: localStorage.getItem('pwa-install-dismissed')
  });
};
